// Sanitize user input to prevent XSS attacks
export function sanitizeInput(input: string): string {
  return (
    input
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Encode special characters
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      // Remove potential script injections
      .replace(/javascript:/gi, '')
      .replace(/on\w+=/gi, '')
      // Trim whitespace
      .trim()
  )
}

// Validate dream content
export interface ValidationResult {
  isValid: boolean
  error: string | null
}

export function validateDreamContent(content: string): ValidationResult {
  const trimmed = content.trim()

  if (!trimmed) {
    return { isValid: false, error: 'Please write something to share.' }
  }

  if (trimmed.length < 10) {
    return { isValid: false, error: 'Please write at least 10 characters.' }
  }

  if (trimmed.length > 2000) {
    return {
      isValid: false,
      error: 'Please keep your entry under 2000 characters.',
    }
  }

  // Check for spam patterns (repeated characters, all caps, etc.)
  const repeatedChars = /(.)\1{10,}/
  if (repeatedChars.test(trimmed)) {
    return { isValid: false, error: 'Please write a meaningful entry.' }
  }

  // Check if mostly uppercase (spam indicator)
  const uppercaseRatio = (trimmed.match(/[A-Z]/g) || []).length / trimmed.length
  if (trimmed.length > 20 && uppercaseRatio > 0.7) {
    return { isValid: false, error: 'Please avoid using all caps.' }
  }

  return { isValid: true, error: null }
}
